// Relative, not '@/', so `npm run test:js` (node --test, no Vite aliases) can load this file.
import { getIframe, getSiteDomain } from '../../shared/iframeStore.js';
// messages: each required error's text, translated in the blade, keyed by its flag without
// "Required" (failure, customMessage, customSeverity, ...).
export default (livewireComponent, messages = {}) => ({

    loading: false,
    showForm: livewireComponent.entangle('showForm'),
    showFailuresList: false,
    showCustomSeverityList: false,
    showViolationsList: false,
    showSolutionsList: false,

    failureRequired: false,
    customSeverityRequired: false,
    customMessageRequired: false,
    customIssueMeaningRequired: false,
    customFixInstructionsRequired: false,
    violationRequired: false,
    solutionRequired: false,
    listenerActive: false,

    styles: livewireComponent.entangle('styles'),
    coordinates: livewireComponent.entangle('coordinates'),
    selector: livewireComponent.entangle('elementSelector'),

    selectedFailure: livewireComponent.entangle('selectedFailure').live,
    customMessage: livewireComponent.entangle('customMessage').live,
    customIssueMeaning: livewireComponent.entangle('customIssueMeaning').live,
    customFixInstructions: livewireComponent.entangle('customFixInstructions').live,
    selectedViolation:livewireComponent.entangle('selectedViolation').live,
    selectedSolutions: livewireComponent.entangle('selectedSolutions'),

    selectedFailureTitle: livewireComponent.entangle('selectedFailureTitle'),
    selectedCustomSeverity: livewireComponent.entangle('selectedCustomSeverity').live,
    selectedViolationTitle: livewireComponent.entangle('selectedViolationTitle'),
    selectedSolutionTitle: livewireComponent.entangle('selectedSolutionTitle'),

    selectedCustomIssue: livewireComponent.entangle('selectedCustomIssue'),
    originalCustomIssue: livewireComponent.entangle('originalCustomIssue'),
    customFailureSuggestions: livewireComponent.entangle('customFailureSuggestions').live,
    isDirty: livewireComponent.entangle('isDirty'),
    updateCustomIssueLivewire : livewireComponent.entangle('updateCustomIssue').live,

    failures: livewireComponent.entangle('failure_techniques'),
    violations: livewireComponent.entangle('violations'),
    solutions: livewireComponent.entangle('solutions'),

    notes: livewireComponent.entangle('notes'),
    steps_to_visible: livewireComponent.entangle('steps_to_visible'),

    highlightedFailure: null,
    highlightedCustomSeverity: null,
    highlightedViolation: null,

    severityIndex: -1,

    search: '',
    searchSolutions: '',

    isDragging: false,
    offset: { x: 0, y: 0 },

    boundScreenshotReceived: null,

    // The status line every error is read out through (#manual-issue-form-status in the blade).
    statusText: '',
    statusTimer: null,
    lastAnnounced: '',

    init() {
        let iframeContainerEl = document.getElementById('visualIframeContainer');
        let visualIframeEl = document.getElementById('visualIframe');

        var pos1 = 0,
            pos2 = 0,
            pos3 = 0,
            pos4 = 0

        this.$watch('showForm', value =>
            {
                if (value) {
                    // Make the DIV element draggable:
                    var elmnt = document.getElementById('manualIssueForm' + 'Header');
                    elmnt.onmousedown = dragMouseDown;

                    let iframe = getIframe();
                    let iframeRect = iframe.getBoundingClientRect();

                    let top = this.coordinates.top - 628; // height of the form
                    let left = this.coordinates.left;

                    // Check if the form is above the iframe
                    if (top < iframeRect.top) {
                        top = iframeRect.top;
                    }


                    // Check if the form is to the left of the iframe
                    if (left < iframeRect.left) {
                        left = iframeRect.left;
                    }

                    // Check if the form is to the right of the iframe
                    if (left + 432 > iframeRect.right) {
                        left = iframeRect.right - 432;
                    }

                    this.styles = {
                        top: top + 'px',
                        left: left + 'px',
                    };

                    setTimeout(() => {
                        // Wait until the form is fully ready in the DOM
                        this.$el.focus();
                        document.querySelector('[key = "failuresListSelect"]').focus();
                    }, 300);

                    // Disable iframe keyboard navigation when modal is open, since we're not locking the tab
                    if(iframeContainerEl && visualIframeEl) {
                        iframeContainerEl.setAttribute('tabindex', '-1');
                        visualIframeEl.setAttribute('tabindex', '-1');
                    } else {
                        console.warn('Failed to set iframe attributes; elements not found!');
                    }

                } else {
                    this.styles = {};
                    if(iframeContainerEl && visualIframeEl) {
                        iframeContainerEl.setAttribute('tabindex', '0');
                        visualIframeEl.removeAttribute('tabindex');
                    } else {
                        console.warn('Failed to reset iframe attributes; elements not found!');
                    }
                }

                function dragMouseDown(e) {
                    e = e || window.event;
                    e.preventDefault();
                    pos3 = e.clientX;
                    pos4 = e.clientY;

                    elmnt = document.getElementById('manualIssueForm');

                    document.onmouseup = closeDragElement;
                    document.onmousemove = elementDrag;
                }

                function elementDrag(e) {
                    e = e || window.event;
                    e.preventDefault();
                    pos1 = pos3 - e.clientX;
                    pos2 = pos4 - e.clientY;
                    pos3 = e.clientX;
                    pos4 = e.clientY;

                    // set the element's new position:
                    elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
                    elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
                    
                    this.styles = {
                        top: elmnt.style.top,
                        left: elmnt.style.left
                    };

                    clearTimeout(this._debounceTimer);
                    this._debounceTimer = setTimeout(() => {
                        livewireComponent.set('styles', this.styles);
                    }, 1000);
                }

                function closeDragElement() {
                    document.onmouseup = null;
                    document.onmousemove = null;
                }
            },
        );
        this.$watch('selectedSolutions', value => {
            if (value.length > 0) {
                this.solutionRequired = false;
                this.selectedSolutionTitle = value.map(solution => solution).join(', ');
            } else if(this.selectFailure != '') {
                this.selectedSolutionTitle = 'Select Recommended Solutions';
            }
        });

        this.$watch('customIssueMeaning', value => {
            if (value) {
                this.customIssueMeaningRequired = false;
            }
        });

        this.$watch('customFixInstructions', value => {
            if (value) {
                this.customFixInstructionsRequired = false;
            }
        });

        this.$watch('customMessage', value => {
            if (value) {
                this.customMessageRequired = false;
            }
        });

        this.boundScreenshotReceived = this.screenshotReceived.bind(this);

        window.Livewire.on('AnnotationOff', (data) => {
            this.cancel(data);
        });
      
        window.Livewire.on('closeManualIssueForm', () => {
            if(this.showForm) {
                this.cancel();
            }
        });

        window.Livewire.on('clearFailureSearch', () => {
            this.search = '';
        });
    },

    selectFailure(failure) {
        this.failureRequired = false;
        this.customMessageRequired = false;
        this.solutionRequired = false;
        this.violationRequired = false;
        this.showFailuresList = false;
        this.selectedFailure = failure._id;
        this.selectedFailureTitle = failure.title;
    },

    openSeverityList() {
        this.showCustomSeverityList = true;
        const severities = this.$wire.customSeverities;
        const idx = severities.indexOf(this.selectedCustomSeverity);
        this.severityIndex = idx >= 0 ? idx : 0;
        this.highlightedCustomSeverity = severities[this.severityIndex];
        this.$nextTick(() => this.$refs.customSeverityList?.focus());
    },

    closeSeverityList() {
        this.showCustomSeverityList = false;
        this.severityIndex = -1;
        this.highlightedCustomSeverity = null;
        this.$nextTick(() => this.$refs.customSeverityButton?.focus());
    },

    focusSeverityIndex(i) {
        const severities = this.$wire.customSeverities;
        if (!severities.length) return;
        this.severityIndex = (i + severities.length) % severities.length;
        this.highlightedCustomSeverity = severities[this.severityIndex];
        this.$nextTick(() => this.$refs[`customSeverity_${this.severityIndex}`]?.focus());
    },

    selectCustomSeverity(severity) {
        this.customSeverityRequired = false;
        this.selectedCustomSeverity = severity;
        this.closeSeverityList();
    },

    selectHighlightedSeverity() {
        if (this.severityIndex < 0) return;
        const severities = this.$wire.customSeverities;
        this.selectCustomSeverity(severities[this.severityIndex]);
    },

    selectViolation(violation) {
        this.violationRequired = false;
        this.selectedViolation = violation._id;
        this.selectedViolationTitle = violation.num + ': ' + violation.handle;
    },

    // Read a message out through the status line. Blanked first and written about 300ms later,
    // as on the team screens, so the line changes even when the same error comes back; a repeat
    // gets a no-break space so the text itself differs too.
    announce(message) {
        this.statusText = '';
        clearTimeout(this.statusTimer);
        this.statusTimer = setTimeout(() => {
            this.statusText = (message !== '' && message === this.lastAnnounced) ? message + '\u00A0' : message;
            this.lastAnnounced = this.statusText;
        }, 300);
    },

    // Read out this side's errors now, and again with the server's (notes, steps to visible)
    // once validateForm is back. Those render through x-input-error, which marks them
    // data-input-error.
    announceErrors(serverCheck, own = []) {
        own = own.filter(Boolean);

        if (own.length) {
            this.announce(own.join(' '));
        }

        Promise.resolve(serverCheck).then(() => this.$nextTick(() => {
            const server = Array.from(this.$root.querySelectorAll('[data-input-error]'))
                .map((el) => el.textContent.trim())
                .filter(Boolean);

            if (server.length) {
                this.announce([...own, ...server].join(' '));
            }
        }));
    },

    submit(updateCustomIssue = false){
        const serverCheck = livewireComponent.call('validateForm');

        this.loading = true;
        this.failureRequired = false;
        this.customSeverityRequired = false;
        this.customMessageRequired = false;
        this.violationRequired = false;
        this.solutionRequired = false;

        if (!this.selectedFailure) {
            this.failureRequired = true;
            this.loading = false;
            this.announceErrors(serverCheck, [messages.failure]);
            return;
        }

        if ((this.selectedFailure == 'custom_failure' ||  this.selectedFailure.includes('custom_')) && !this.customMessage) {
            this.customMessageRequired = true;
            this.loading = false;
            this.announceErrors(serverCheck, [messages.customMessage]);
            return;
        }

        if( (this.selectedFailure == 'custom_failure' ||  this.selectedFailure.includes('custom_')) && !this.customIssueMeaning) {
            this.customIssueMeaningRequired = true;
            this.loading = false;
            this.announceErrors(serverCheck, [messages.customIssueMeaning]);
            return;
        }

        if( (this.selectedFailure == 'custom_failure' ||  this.selectedFailure.includes('custom_')) && !this.customFixInstructions) {
            this.customFixInstructionsRequired = true;
            this.loading = false;
            this.announceErrors(serverCheck, [messages.customFixInstructions]);
            return;
        }

        if (!this.selectedCustomSeverity || this.selectedCustomSeverity == 'Select a Failure First' || this.selectedCustomSeverity == 'Select a Severity') {
            this.customSeverityRequired = true;
            this.loading = false;
            this.announceErrors(serverCheck, [messages.customSeverity]);
            return;
        }

        if(this.solutions.length != 0 && this.selectedSolutions.length == 0  && this.selectedFailure != 'custom_failure' && !this.selectedFailure.includes('custom_')) {
            this.solutionRequired = true;
        }

        if(this.violations.length != 0 && !this.selectedViolation && this.selectedFailure != 'custom_failure' && !this.selectedFailure.includes('custom_')) {
            this.violationRequired = true;
        }

        if(this.failureRequired || this.violationRequired || this.solutionRequired || this.customMessageRequired || this.customSeverityRequired) {
            this.loading = false;
            this.announceErrors(serverCheck, [
                this.violationRequired && messages.violation,
                this.solutionRequired && messages.solution,
            ]);
            return;
        }

        this.announceErrors(serverCheck);

        if(this.isDirty && this.selectedFailure != 'custom_failure' && this.selectedFailure.includes('custom_')) {
            this.updateCustomIssueLivewire = updateCustomIssue;
        }

        // send request to iframe to get screenshot
        let iframe = getIframe();
        let site_domain = getSiteDomain();
        iframe.contentWindow.postMessage(
            {
                function: "getScreenshot",
                selector: this.selector,
            },
            site_domain
        );

        if(!this.listenerActive) {
            window.addEventListener("message", this.boundScreenshotReceived, true);
            this.listenerActive = true;
        }

    },

    callCreateIssue: function() {
        livewireComponent.call('createManualIssue').then(($data) => {
            if($data != false) {
                this.restDefaultBehavior()
                window.Livewire.dispatch('viewIssues')
                this.restForm()
            } else {
                this.loading = false;
                livewireComponent.call('flashMessage')
            }
        }).catch((error) => {
            console.error('Could not create issue', error)
        })
    },

    screenshotReceived(event) {
        if (event.origin == getSiteDomain()) {
            if (event.data.msg == "screenshot") {
                window.removeEventListener("message", this.boundScreenshotReceived, true);
                this.listenerActive = false;
                livewireComponent.call('saveScreenshot', event.data).then(() => {
                    this.callCreateIssue();
                }).catch((error) => {
                    console.error('Could not save screenshot', error)
                    this.callCreateIssue();
                });
            }
        }
    },


    cancel(data){
        this.restForm()
        this.restDefaultBehavior()
        window.Livewire.dispatch(data.newMode || 'viewIssues');
    },

    restDefaultBehavior() {
        let iframe = getIframe();
        let site_domain = getSiteDomain();
        iframe.contentWindow.postMessage(
            {
                function: "defaultBehavior",
            },
            site_domain
        );
    },

    restForm() {
        this.failureRequired = false;
        this.customSeverityRequired = false;
        this.customMessageRequired = false;
        this.customIssueMeaningRequired = false;
        this.customFixInstructionsRequired = false;
        this.violationRequired = false;
        this.solutionRequired = false;

        this.violations = [];
        this.solutions = [];
        this.search = '';

        this.selectedFailure = '';
        this.customFixInstructions = '';
        this.customMessage = '';
        this.customIssueMeaning = '';
        this.selectedFailureTitle = 'Select a Failure';
        this.selectedCustomSeverity = 'Select a Failure First';
        this.selectedViolation = '';
        this.selectedViolationTitle = 'Select a Failure First';
        this.selectedSolutions = [];
        this.selectedSolutionTitle = 'Select a Failure First';
        this.isDirty = false;
        this.originalCustomIssue = null;
        this.selectedCustomIssue = null;

        this.notes = '';
        this.steps_to_visible = '';

        this.loading = false;
        this.showForm = false;
    }

});
